export const FIREBASE = {
  apiKey: "AIzaSyBSWO7MqHA9g1pm8eUTCKBhD89Sb7j2nbI",
  authDomain: "titanplan-1175.firebaseapp.com",
  databaseURL: "https://titanplan-1175.firebaseio.com",
  projectId: "titanplan-1175",
  storageBucket: "titanplan-1175.appspot.com",
  messagingSenderId: "1022502610261",
  appId: "1:1022502610261:web:501c3e5280e99b09f83bdc",
}